import Vue from './common/vue-common';
import cr$ from "../common/crquery";
import HeaderCartDesktop from "./components/header/HeaderCartDesktop";
import HeaderCartMobile from "./components/header/HeaderCartMobile";
import HeaderCartDrawer from "./components/header/HeaderCartDrawer";

cr$.ready(() => requestIdleCallback(() => {
    if (cr$.byId('header-cart-desktop').exists()) {
        new Vue(HeaderCartDesktop)
    }

    if (cr$.byId('header-cart-mobile').exists()) {
        new Vue(HeaderCartMobile)
    }

    if (cr$.byId('header-cart-drawer').exists()) {
        new Vue(HeaderCartDrawer)
    }
}));
